/**
 * Whether the membership pays for each appointment of the booking, in the order they were posted, as answered by
 * the backend. Undefined when that is not known, for anything but a membership the consumer owns, or when it is
 * about another set of appointments than the booking has now.
 */
export const membershipCoverage = (subscription, appointmentCount) => {
    if (!subscription || subscription.type !== 'membership' || !subscription.subscriptionId) {
        return undefined;
    }
    if (!subscription.coverage || subscription.coverage.length !== appointmentCount) {
        return undefined;
    }
    return subscription.coverage;
};
export const membershipLimitState = (subscription, appointmentCount, canPayOnline) => {
    const coverage = membershipCoverage(subscription, appointmentCount);
    if (!coverage || !coverage.includes(false)) {
        return 'full';
    }
    return canPayOnline ? 'addPayment' : 'addMembership';
};
/** What the appointments the membership does not pay for cost together: the prices are in the order of the coverage. */
export const membershipUncoveredTotal = (coverage, prices) => coverage.reduce((sum, covered, i) => { var _a; return sum + (covered ? 0 : ((_a = prices[i]) !== null && _a !== void 0 ? _a : 0)); }, 0);
